require('./bootstrap');

// Use our simplified adapter instead of the ES module implementation
require('./verify-tt/verify_cert.js');

// jetapo scripts
// require('./jetapo/vendor/jquery-3.5.0.min');
require('./jetapo/vendor/jquery-migrate-3.1.0.min');
require('./jetapo/vendor/bootstrap.bundle.min');
require('./jetapo/vendor/modernizr-3.10.0.min');
require('./jetapo/plugins/plugins.min');
require('./jetapo/main');

// custom scripts
require('./scripts');
require('./datepicker/js/bootstrap-datepicker');
require('./chosen/chosen.jquery');
require('./chosen/init');
require('./summernote/summernote-bs4');

// jPList
require('../../public/plugins/jplist-master/js/jplist.core.min');
require('../../public/plugins/jplist-master/js/jplist.jquery-ui-bundle.min');
require('../../public/plugins/jplist-master/js/jplist.sort-bundle.min');
require('../../public/plugins/jplist-master/js/jplist.textbox-filter.min');
require('../../public/plugins/jplist-master/js/jplist.pagination-bundle.min.js');
require('../../public/plugins/jplist-master/js/jplist.filter-toggle-bundle.min');

// bootstrap select
require('./bootstrap-select/bootstrap-select.min');
require('./verify-tt/verify_cert.js')
